import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { RetailerTiersService } from '../retailer-tiers.service';

@Component({
  selector: 'app-manage-tiers',
  templateUrl: './manage-tiers.component.html',
  styleUrls: ['./manage-tiers.component.scss']
})
export class ManageTiersComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {
  retailerTierId: any;
  tiersForm: FormGroup;
  constructor(private fb: FormBuilder, private retailerTierService: RetailerTiersService, private activeRoute: ActivatedRoute, private router: Router) {
    super();
    this.retailerTierId = this.activeRoute.snapshot.params.retailerTierId;
    this.tiersForm = this.fb.group({
      retailerTierName: ['', Validators.required],
      salesAmount: ['', Validators.required]
    })
    if (this.retailerTierId && this.retailerTierId) {
      retailerTierService.getRetailerTierDetails(this.retailerTierId).subscribe(res => {
        if (res['httpcode'] == 200) {
          console.log(res.data)
          this.tiersForm.patchValue({
            retailerTierName: res.data.retailerTierName,
            salesAmount: res.data.salesAmount
          })

        }
      })
    }
  }

  ngOnInit(): void {
    super.ngOnInit()
  }
  ngOnDestroy(): void {
    super.ngOnDestroy()
  }

  addEditTierSubmit(e) {
    if (this.tiersForm.invalid) return;
    let formData = {}
    if(this.retailerTierId){
      formData = {
        "retailerTierId": this.retailerTierId,
        "retailerTierName": this.tiersForm.controls['retailerTierName'].value,
        "salesAmount": this.tiersForm.controls['salesAmount'].value,
      }
      this.retailerTierService.updateTier(formData).subscribe(res => {
        if(res['httpcode'] == 200){
          this.toastrService.success('Tier updated successfully', 'Success!')
          this.router.navigate([`features/retailers/retailer-tiers/all-tiers`])
        }
      })
    } else{
      formData = {
        "retailerTierName": this.tiersForm.controls['retailerTierName'].value,
        "salesAmount": this.tiersForm.controls['salesAmount'].value,
      }
      this.retailerTierService.createTier(formData).subscribe(res => {
        if(res['httpcode'] == 200){
          this.toastrService.success('Tier created successfully', 'Success!')
        }
      })
    }
  }
}
